package provider

import androidx.compose.runtime.*
import api.*
import kotlinx.browser.*
import org.w3c.dom.*

class LocalizationProvider(initialLanguage: LanguageType) : Localization {

    companion object {
        fun build(): LocalizationProvider {
            val stored = window.localStorage["language"]?.let { LanguageType.find(it) }
            // navigator.languages = user's preference order; first supported one wins
            val preferred = stored
                ?: window.navigator.languages.firstNotNullOfOrNull { LanguageType.find(it) }
                ?: LanguageType[window.navigator.language]
            return LocalizationProvider(preferred)
        }
    }

    override var language: LanguageType by mutableStateOf(initialLanguage)
        private set


    override fun change(new: LanguageType) {
        window.localStorage["language"] = new.short.first()
        language = new
    }
}
